import IconButton from '@mui/material/IconButton';

import { styled } from '@mui/material/styles';

export const ListCellWrapper = styled('div', {
  label: 'ListCellWrapper',
})(() => ({
  position: 'relative',
  height: '100%',

  '&:focus': {
    zIndex: 10,
  },
}));

export const FieldWrapper = styled('div', {
  label: 'FieldWrapper',
})(() => ({
  position: 'relative',
  height: '100%',
}));

export const FieldInput = styled('input', {
  label: 'FieldInput',
})(() => ({
  width: '100%',
  paddingLeft: 8,
  paddingRight: 28,
  paddingBottom: 0,
  paddingTop: 0,
  border: '0 none',
  outline: 'none',
  height: '100%',

  '&:is(textarea)': {
    boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)',
    backgroundColor: '#fff',
    resize: 'none',
    position: 'fixed',
  },
}));

export const FieldWarningIcon = styled('div', {
  label: 'FieldWarningIcon',
})(() => ({
  position: 'absolute',
  top: 2,
  left: 0,

  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
}));
